import { CONTAINER_TYPES } from 'web-interactives-data/constants/ContainerConstants';
export const PREVIEW_DEVICES = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  TABLET: 'tablet'
};
export const TYPES_WITH_PREVIEW_ON_PAGE = [CONTAINER_TYPES.BANNER, CONTAINER_TYPES.MODAL, CONTAINER_TYPES.SLIDE_IN];